var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HistoricoNotificacoes.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6b4204fa!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HistoricoNotificacoes.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/notificacao/HistoricoNotificacoes.vue
// module id = 904
// module chunks = 1